module.exports = __webpack_public_path__ + "media/ads/Test_300x250-fbe2ccda.jpg";